import { faAngleLeft, faAngleRight, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, IconButton, Toolbar } from '@material-ui/core'
import { Theme, makeStyles } from '@material-ui/core/styles'

import { ExplorePreviewRecord } from './HighschoolPreviewDrawer'

const useStyles = makeStyles<Theme>((theme) => {
  return {
    previewToolbar: {
      backgroundColor: theme.palette.primary.main,
      justifyContent: 'space-between',
      width: '100%',
    },
    toolbarActionButton: {
      color: 'white',
      fontSize: '1.5em',
    },
  }
})

interface PreviewDrawerNav {
  onClose: () => void
  highschool?: ExplorePreviewRecord | null
  onClickNext: (highschoolId?: string) => void
  hasNext: boolean
  onClickPrev: (highschoolId?: string) => void
  hasPrevious: boolean
  navDisabled?: boolean
}

const PreviewDrawerNav = ({
  onClose,
  highschool,
  onClickNext,
  hasNext,
  onClickPrev,
  hasPrevious,
  navDisabled,
}: PreviewDrawerNav) => {
  const classes = useStyles()
  return (
    <Toolbar
      variant="dense"
      className={classes.previewToolbar}
    >
      <Box>
        <IconButton
          className={classes.toolbarActionButton}
          aria-label="Previous High School"
          edge="start"
          size="medium"
          disabled={!hasPrevious || navDisabled}
          onClick={() => {
            onClickPrev(highschool?.id)
          }}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </IconButton>
        <IconButton
          aria-label="Next High School"
          className={classes.toolbarActionButton}
          size="medium"
          disabled={!hasNext || navDisabled}
          onClick={() => onClickNext(highschool?.id)}
        >
          <FontAwesomeIcon icon={faAngleRight} />
        </IconButton>
      </Box>
      <IconButton
        className={classes.toolbarActionButton}
        edge="end"
        size="medium"
        onClick={onClose}
      >
        <FontAwesomeIcon icon={faTimes} />
      </IconButton>
    </Toolbar>
  )
}

export default PreviewDrawerNav
